import styled from 'styled-components'
import { lightGray, mildGray, softGray, menuShadow, mildBlue } from '../../styles/variables'
import { fieldLabel } from '../../styles/common'

const TagsContainer = styled.div`

  display: flex;
  flex-direction: column;

  ${fieldLabel}

  &.disabled {
    opacity: 0.7;
  }
`

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const TagContainer = styled.div`
  margin-right: 16px;
  position: relative;
  margin-bottom: 8px;
`

const Tag = styled.div`
  box-sizing: border-box;
  text-align: center;
  border: 2px solid ${lightGray};
  padding: 10px 30px;
  outline: none;
  border-radius: 6px;
  font-size: 14px;
  background: ${lightGray};
  color: white;
  font-weight: bold;
  cursor: default;
  white-space: nowrap;
`

const AddTag = styled.div`
  box-sizing: border-box;
  text-align: center;
  border: none;
  padding: 10px 40px;
  outline: none;
  border-radius: 6px;
  font-size: 14px;
  border: 2px solid ${lightGray};
  color: ${lightGray};
  font-weight: bold;
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`

const Close = styled.div`
  background: white;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
  color: ${mildGray};
  overflow: hidden;
  display: flex;
  flex-direction: row;
  box-shadow: ${menuShadow};
  font-size: 18px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`

const Menu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: white;
  padding: 8px 0;
  box-shadow: ${menuShadow};
  border-radius: 6px;
  z-index: 4;
  transition: all 0.1s ease 0s;
`

const MenuItem = styled.div`
  padding: 8px 32px;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: ${softGray};
  }

  &.focused {
    background: ${mildBlue};
  }
`

const Info = styled.i`
  margin-left: 20px;
  opacity: 0.7;
  font-size: 12px;
`

const Small = styled.small`
  color: #ababab;
  user-select: none;
  font-size: 12px;
  margin-left: 10px;
`

export default {
  TagsContainer,
  TagContainer,
  Tags,
  Tag,
  AddTag,
  Close,
  Menu,
  MenuItem,
  Info,
  Small,
}
